import React from 'react';

interface IconHomeProps {
    iconClasses?: string;
}

const IconHome: React.FC<IconHomeProps> = ({ iconClasses }) => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="-2 -0.5 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            className={`icon icon-home ${iconClasses ?? ''}`}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 7.08826L10.4085 0.792624C9.30202 -0.264207 7.50805 -0.264208 6.40161 0.792624L0 6.90693V20H6.61111V14.5876C6.61111 13.5912 7.45677 12.7835 8.5 12.7835C9.54323 12.7835 10.3889 13.5912 10.3889 14.5876V20H17V7.08826ZM7.73727 2.06832L1.88889 7.65423V18.1959H4.72222V14.5876C4.72222 12.5949 6.41359 10.9794 8.5 10.9794C10.5864 10.9794 12.2778 12.5949 12.2778 14.5876V18.1959H15.1111V7.83555L9.0729 2.06832C8.70409 1.71605 8.10607 1.71605 7.73727 2.06832Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconHome;
